import React from "react";
import "./about.css";
import Info from "./Info";

const About = () => {
  return (
    <section className="about section" id="about">
      <h2 className="section__title">Sobre mim</h2>
      <span className="section__subtitle">Uma pequena introdução</span>
      <div className="about__container container grid">
        <div className="about__data">
          <p className="about__description">
            Sou um profissional apaixonado e dedicado no campo do
            desenvolvimento de software, especializado em back-end e com
            experiência substancial em desenvolvimento fullstack. A busca
            contínua por desafios e a paixão pelos avanços tecnológicos são
            motores que impulsionam minha carreira.
          </p>
          <p className="about__description">
          Tenho familiaridade em Java,
            Spring Boot e estou me dedicando ao aprendizado de práticas de
            DevOps e front-end com React. Com três anos de experiência em
            infraestrutura, estou em transição para me consolidar no campo do
            desenvolvimento de software. Sou um profissional proativo,
            dedicado e sempre em busca de soluções inovadoras. Tenho uma
            habilidade natural para assimilar rapidamente novos conhecimentos e
            me adaptar a diferentes desafios.
          </p>
          <Info />
          
        </div>
      </div>
    </section>
  );
};

export default About;
